var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#989998;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,29.5c29.8,0,58.7,5.8,85.8,17.3c26.3,11.1,49.8,27,70.1,47.3c20.3,20.3,36.2,43.8,47.3,70.1 c11.5,27.2,17.3,56,17.3,85.8s-5.8,58.7-17.3,85.8c-11.1,26.3-27,49.8-47.3,70.1c-20.3,20.3-43.8,36.2-70.1,47.3 c-27.2,11.5-56,17.3-85.8,17.3s-58.7-5.8-85.8-17.3c-26.3-11.1-49.8-27-70.1-47.3s-36.2-43.8-47.3-70.1 c-11.5-27.2-17.3-56-17.3-85.8s5.8-58.7,17.3-85.8c11.1-26.3,27-49.8,47.3-70.1s43.8-36.2,70.1-47.3 C191.3,35.3,220.2,29.5,250,29.5 M250,6.5C115.5,6.5,6.5,115.5,6.5,250s109,243.5,243.5,243.5s243.5-109,243.5-243.5 S384.5,6.5,250,6.5L250,6.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.9,241.4h35.9v25.9h-35.9v40.5h-27.3v-40.5h-36v-25.9h36v-38.8h27.3V241.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.2,214.3c0,5.5-1.1,10.7-3.2,15.7c-2.2,5-5,9.9-8.4,14.5c-3.4,4.7-7.3,9.2-11.6,13.5 c-4.3,4.3-8.6,8.4-12.7,12.3c-2.2,2-4.5,4.3-7,6.8c-2.5,2.5-4.9,5.1-7.2,7.7c-2.3,2.6-4.3,5-6.1,7.2c-1.8,2.2-2.9,4.1-3.3,5.5h64.2 v26.9H76.1c-0.3-1.6-0.4-3.6-0.4-6s0-4.2,0-5.2c0-6.9,1.1-13.2,3.3-19c2.2-5.7,5.1-11.1,8.7-16.1s7.7-9.6,12.2-13.9 s9-8.6,13.5-12.9c3.4-3.3,6.7-6.4,9.7-9.4c3-2.9,5.7-5.8,8-8.6s4.1-5.6,5.4-8.4c1.3-2.8,1.9-5.6,1.9-8.5c0-6.3-1.8-10.8-5.4-13.4 c-3.6-2.6-8-3.9-13.4-3.9c-3.9,0-7.5,0.6-10.9,1.8s-6.5,2.7-9.3,4.3c-2.8,1.7-5.2,3.3-7.2,5s-3.5,3-4.5,4l-16-22.4 c6.3-5.9,13.7-10.7,22.1-14.5s17.4-5.7,27.1-5.7c8.8,0,16.3,1,22.6,3s11.5,4.8,15.6,8.5s7.1,8.1,9.1,13.4S171.2,207.7,171.2,214.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.8,206.1c4.2-1.7,8.5-3.7,13-5.9s8.9-4.7,13.3-7.3c4.3-2.7,8.4-5.5,12.4-8.4s7.5-6.1,10.7-9.4h22.4v149.4 h-32.1V216.9c-4.3,2.9-9.1,5.5-14.4,7.9c-5.3,2.4-10.5,4.4-15.5,6.1L201.8,206.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg21);
export default __webpack_public_path__ + "static/media/21+.c00cc5cf0b380c4206a82bb978ec4afa.svg";
export { ForwardRef as ReactComponent };